module.exports = __webpack_public_path__ + "static/media/pic10.be49d122.jpg";